import type { Context } from '@white-label-types/middleware';
import type { AuthObject } from '@white-label-types/auth';

import { handleSSOToken, isDedicatedFlow } from '@white-label-helper/dedicated-flow';
import { datadogRum } from '@datadog/browser-rum';
interface ContextWithInstalledModules extends Context {
  $auth: AuthObject;
}

const dedicatedSSO = async ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  redirect,
  $auth,
  route,
  app,
}: ContextWithInstalledModules): Promise<unknown> => {
  if (!process.client) {
    return;
  }

  if(isDedicatedFlow(route)) {
    // helper to get context for datadog logging
    const getContext = () => ({
      file: 'wl-ecom > middleware > dedicated-sso.ts',
      authObj: $auth || '',
      isAuthenticated: $auth?.isAuthenticated || '',
    });

    // get the sso token from cookies, falling back to query parameter
    // (third-party cookie restrictions may prevent the iframe cookie bridge from setting the cookie)
    const ssoTokenCookie = app['$cookies'].get('sso_token');
    const ssoTokenQuery = route.query?.['sso_token']?.toString();
    const ssoToken = ssoTokenCookie || ssoTokenQuery;

    try {
      await handleSSOToken($auth, ssoToken);

      if (!$auth.isAuthenticated) {
        datadogRum.addError(
          new Error('Dedicated Flow - User not authorised:'),
          getContext(),
        );
        // if not authenticated, redirect to where user came from or ecom home
        redirect($auth.returnUrl || '/');
      }
    } catch (error) {
      datadogRum.addError(
        new Error('Dedicated Flow - Error authorising user:', { cause: error }),
        getContext(),
      );

      try {
        await $auth.logout();
      } catch (error) {
        console.error(error)
        datadogRum.addError(
          new Error('Dedicated Flow - auth unable to logout:', { cause: error }));
      }
    }
  }
};

export default dedicatedSSO;
